module.exports = __webpack_public_path__ + "img/logo-wordtype-white@2x.2aa0f1a3.png";